import React from 'react'
import * as Accordion from '@radix-ui/react-accordion'
import '../styles/Faq.css'

const faqs = [
  {
    id: '01',
    title: 'საიტის დამზადება ფასები - რა შედის პაკეტში?',
    text: 'საიტის დამზადების ფასები განისაზღვრება პროექტის სირთულით, ფუნქციონალითა და ინდივიდუალური მოთხოვნებით. ყველა პაკეტი მოიცავს მობილურზე სრულად მორგებულ დიზაინს, სწრაფ ჩატვირთვას, უსაფრთხო კავშირის უზრუნველყოფას (რაც იცავს მომხმარებლის მონაცემებს) და 1 თვიან ტექნიკურ მხარდაჭერას. დამატებით პაკეტებში შედის ადმინ პანელი, კონტენტის მართვის სისტემა (CMS) და SEO ოპტიმიზაცია, რაც გეხმარებათ Google-ში უკეთ გამოჩენაში.',
  },
  {
    id: '02',
    title: 'საიტის დამზადება უფასოდ შეიძლება?',
    text: 'უფასო საიტები არსებობს, მაგრამ ისინი სერიოზული ბიზნესისთვის იშვიათად არის საკმარისი. შეზღუდული ფუნქციონალი, უცხო ბრენდის ლოგოები და დაბალი სიჩქარე ხშირად აზიანებს თქვენი კომპანიის იმიჯს. თუ გსურთ ხარისხიანი ონლაინ პლატფორმა, რომელიც ზრდაზე და კლიენტების მოზიდვაზეა ორიენტირებული, საჭიროა პროფესიონალურად შექმნილი ვებსაიტი. ჩვენთან ინვესტიცია იწყება მხოლოდ 500₾-დან.',
  },
  {
    id: '03',
    title: 'ვებსაიტის შექმნა - როგორ მუშაობს პროცესი?',
    text: 'პროცესი იწყება თქვენი ბიზნესისა და მიზნების გაცნობით. ვარკვევთ რა შედეგის მიღება გსურთ და ამის მიხედვით ეტაპობრივად ვიწყებთ საიტის აწყობას. თითოეული ნაწილი სრულად მორგებულია თქვენს ბრენდზე და თანხმდება თქვენთან პროცესის განმავლობაში. საბოლოოდ ვამოწმებთ ტექნიკურ მხარეს, ვამზადებთ საძიებო სისტემებისთვის და ვუშვებთ ონლაინ. საშუალო ვადა: 1–3 კვირა.',
  },
  {
    id: '04',
    title: 'Wordpress საიტის აწყობა - რატომ გირჩევთ React-ს?',
    text: 'React და Node.js საშუალებას გვაძლევს შევქმნათ პროფესიონალური მაღალი კლასის საიტები, სადაც დიზაინი და ფუნქციონალი ზუსტად თქვენს მოთხოვნებზეა მორგებული. ბრენდის სრულყოფილი რეალიზაცია ვებ სივრცეში — აირჩიეთ საუკეთესო თქვენი ბიზნესისთვის',
  },
  {
    id: '05',
    title: 'საიტების დამზადება იაფად - ღირს თუ არა?',
    text: '„იაფი საიტი“ ხშირად ნიშნავს შაბლონურ დიზაინს, ნელ სიჩქარეს და ტექნიკურ პრობლემებს, რომლებიც მოგვიანებით ძვირად დაგიჯდებათ. ჩვენ გთავაზობთ კონკურენტულ ფასებს — 1500₾-დან — გარანტირებული მაღალი ხარისხით. კარგი საიტი არის ინვესტიცია, რომელიც 24/7-ზე მუშაობს თქვენი ბიზნესისთვის, ამაღლებს თქვენი ბრენდის იმიჯს ონლაინ და სთავაზობს მომხმარებელს უპრობლემო გამოცდილებას.',
  },
  {
  "id": "06",
  "title": "ვებ გვერდის დამზადება ფასი - რაზე არის დამოკიდებული?",
  "text": "ვებ გვერდის საბოლოო ფასი დამოკიდებულია რამდენიმე ფაქტორზე: გვერდების რაოდენობაზე, დიზაინის სირთულესა და სპეციალურ ფუნქციონალზე (გადახდის სისტემა, ადმინ პანელი, ენების დამატება).\nსაწყისი კონსულტაცია უფასოა.\nდაგვიკავშირდით: +995 574 06 54 69"
},
  {
    id: '07',
    title: 'საიტის დიზაინები - რა ვარიანტები გვაქვს?',
    text: 'ჩვენ ვქმნით ინდივიდუალურ დიზაინებს - არ ვიყენებთ მზა შაბლონებს. თითოეული საიტი იქმნება თქვენი ბრენდის იდენტობიდან გამომდინარე: ფერები, შრიფტები, layout და UX ყველაფერი მორგებულია თვენს გემოვნებაზე.',
  },
]

function Faq() {
  return (
    <section className="faq-section">
      <div className="faq-inner">

        <div className="faq-header">
          <span className="faq-line faq-line--left" />
          <h2 className="faq-heading">ხშირად დასმული კითხვები</h2>
          <span className="faq-line faq-line--right" />
        </div>

        <Accordion.Root className="faq-accordion" type="single" collapsible>
          {faqs.map((item) => (
            <Accordion.Item className="faq-item" key={item.id} value={item.id}>

              <Accordion.Header>
                <Accordion.Trigger className="faq-trigger">
                  <div className="faq-trigger-left">
                    <span className="faq-num">{item.id}</span>
                    <span className="faq-title">{item.title}</span>
                  </div>
                  <span className="faq-icon">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                      stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M6 9l6 6 6-6" />
                    </svg>
                  </span>
                </Accordion.Trigger>
              </Accordion.Header>

              <Accordion.Content className="faq-content">
                <p className="faq-text">{item.text}</p>
              </Accordion.Content>

            </Accordion.Item>
          ))}
        </Accordion.Root>

      </div>
    </section>
  )
}

export default Faq